export default __webpack_public_path__ + "static/media/image12.f8e5d007.jpeg";